<template>
  <div class="m_container">
    <div v-if="bannerList.length" ref="sliderWrapper" class="sliderWrapper">
      <Slider>
        <div v-for="(item,index) in bannerList" :key="index">
          <a href="#">
            <img :src="item.picUrl" alt="">
          </a>
        </div>
      </Slider>
    </div>
  </div>
</template>

<script>
import Slider from '@/components/Slider/index'

export default {
  name: 'MyExam',
  components: { Slider },
  data() {
    return {
      bannerList: [
        { picUrl: require('../../assets/images/apple-1.jpg') },
        { picUrl: require('../../assets/images/apple-2.jpg') },
        { picUrl: require('../../assets/images/apple-3.jpg') }
      ]
    }
  },

  created() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.m_container{
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
</style>
